import styles from './noData.module.scss'

interface NoDataProps {
	title?: string | React.ReactNode
	desc?: string | React.ReactNode
	extra?: React.ReactNode
	style?: React.CSSProperties
	icon?: React.ReactNode
}

/**
 * 데이터 없음 컴포넌트
 *
 * @param title 제목
 * @param desc 설명
 * @param extra 추가 내용
 * @param style 스타일
 */
const NoData = ({title, desc, extra, style, icon}: NoDataProps) => {
	return (
		<div className={styles['no-data-wrap']} style={style}>
			<i>{icon ? icon : '😢'}</i>
			{title && <b>{title}</b>}
			{desc && <p>{desc}</p>}
			{extra && extra}
		</div>
	)
}

export default NoData
